import { useTranslation } from "react-i18next";
import { useMapProviderStore, type MapProvider } from "@/map/stores/useMapProviderStore";
import { cn } from "@/ui/lib/utils";

const PROVIDERS: {
  value: MapProvider;
  labelKey: "preferences.googleLabel" | "preferences.libreLabel";
  descriptionKey: "preferences.googleDescription" | "preferences.libreDescription";
}[] = [
  { value: "google", labelKey: "preferences.googleLabel", descriptionKey: "preferences.googleDescription" },
  { value: "libre", labelKey: "preferences.libreLabel", descriptionKey: "preferences.libreDescription" },
];

const PreferencesSettings = () => {
  const { t } = useTranslation("settings");
  const provider = useMapProviderStore((s) => s.provider);
  const setProvider = useMapProviderStore((s) => s.setProvider);

  return (
    <div className="p-6 max-w-2xl">
      <div className="mb-6">
        <h1 className="text-2xl font-bold">{t("preferences.title")}</h1>
        <p className="text-sm text-muted-foreground">{t("preferences.description")}</p>
      </div>

      <section className="rounded-xl border bg-card p-5">
        <h2 className="text-base font-semibold">{t("preferences.mapProviderTitle")}</h2>
        <p className="mb-4 text-sm text-muted-foreground">
          {t("preferences.mapProviderDescription")}
        </p>
        <div className="grid gap-3 sm:grid-cols-2">
          {PROVIDERS.map((p) => {
            const active = provider === p.value;
            return (
              <button
                key={p.value}
                type="button"
                onClick={() => setProvider(p.value)}
                aria-pressed={active}
                className={cn(
                  "rounded-lg border p-4 text-left transition-colors",
                  active
                    ? "border-primary bg-primary/5 ring-2 ring-primary/20"
                    : "border-border hover:bg-accent/50",
                )}
              >
                <div className="flex items-center justify-between">
                  <span className="font-medium">{t(p.labelKey)}</span>
                  {active && (
                    <span className="text-xs font-semibold text-primary">{t("preferences.active")}</span>
                  )}
                </div>
                <p className="mt-1 text-xs text-muted-foreground">{t(p.descriptionKey)}</p>
              </button>
            );
          })}
        </div>
      </section>
    </div>
  );
};

export default PreferencesSettings;
